import { render, staticRenderFns } from "./IntegrationWidget.vue?vue&type=template&id=9a44b6f4&scoped=true"
import script from "./IntegrationWidget.vue?vue&type=script&lang=js"
export * from "./IntegrationWidget.vue?vue&type=script&lang=js"
import style0 from "./IntegrationWidget.vue?vue&type=style&index=0&id=9a44b6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a44b6f4",
  null
  
)

export default component.exports